export default __webpack_public_path__ + "static/media/loc-site.e3b2a327.webp";